export class FormControl {
    value;
    disabled;
    hasError = false;
    required;
    defaultValue;
    disabledValue;
    resetValueOnEnable = true;
    constructor(value, disabled, required, defaultValue, disabledValue) {
        this.value = value;
        this.disabled = disabled;
        this.required = required;
        this.defaultValue = defaultValue;
        this.disabledValue = disabledValue;
    }

    withResetValueOnEnable = resetValueOnEnable => ({
        ...this, resetValueOnEnable
    });

    withValue = value => ({
        ...this, value
    });
}


// WEBPACK FOOTER //
// ./src/modules/record/components/forms/FormControl.js